import { render, staticRenderFns } from "./TranslationsSidebar.vue?vue&type=template&id=48544028&"
import script from "./TranslationsSidebar.vue?vue&type=script&lang=js&"
export * from "./TranslationsSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports